import React from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

const ValidatedAutocomplete = ({
  name,
  control,
  rules = { required: 'This field is required.' },
  defaultValue,
  options,
  isLoading,
  inputLabel,
  getOptionLabel,
  onChange = () => {},
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    defaultValue={defaultValue}
    render={({ field, fieldState }) => (
      <Autocomplete
        disablePortal
        id={name}
        name={field.name}
        value={options.find((o) => o.id.toString() === field.value) || null}
        onChange={(event, selectedOption) => {
          onChange(event, selectedOption);
          field.onChange(selectedOption?.id.toString());
        }}
        options={options}
        getOptionLabel={getOptionLabel}
        renderInput={(params) => (
          <TextField
            {...params} // eslint-disable-line react/jsx-props-no-spreading
            fullWidth
            label={inputLabel}
            InputProps={{
              ...params.InputProps,
              startAdornment: isLoading && <CircularProgress size={18} />,
            }}
            onBlur={field.onBlur}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
          />
        )}
      />
    )}
  />
);

export default ValidatedAutocomplete;
